import logger from './logger';

export async function sleep(time: number) {
  return new Promise(resolve => setTimeout(resolve, time));
}

export function retryableFn<Argument extends any[], ReturnVal>(
  fn: (...args: Argument) => Promise<ReturnVal>,
  name?: string,
  maxCount = 3,
  backoffScale = 1000
) {
  return async (...args: Argument): Promise<ReturnVal> => {
    let count = 0;
    let result: ReturnVal | undefined;
    let success = false;
    do {
      try {
        result = await fn(...args);
        success = true;
      } catch (e) {
        // progressively backoff the request
        const sleepTime = Math.round(count * backoffScale + Math.random() * 50);
        count++;
        logger.info(`Error invoking ${name || fn.name} - retrying: ${count}`);
        await sleep(sleepTime);
      }
    } while (!success && count < maxCount);

    if (result === undefined) {
      throw new Error(`Retrying ${name || fn.name} ${count} times - failed`);
    }

    return result;
  };
}
